import React, { useContext, useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContextProvider';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { toast } from 'react-toastify';

function RegisterFrom({ history }) {
  const { verifyUser } = useContext(AuthContext);
  const { register, handleSubmit, watch, errors } = useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [send, setSend] = useState(false);
  const [isVerification, setIsVerification] = useState(false);

  let serverUrl = process.env.REACT_APP_SERVER_URL;

  const [showPass, setShowPass] = useState(false);

  const togglePassword = () => {
    setShowPass(!showPass);
  };

  let watchPass = watch('password');

  const submitForm = async (data) => {
    delete data.termsandconditions;
    if (!send) {
      setLoading(true);

      if (data.avatar[0] instanceof File) {
        const formData = new FormData();
        formData.append('image', data.avatar[0]);
        const response = await fetch(`${process.env.REACT_APP_FILE_UPLOAD_URL}api/video/image/`, {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: process.env.REACT_APP_VIDEO_AUTH,
          },
        }).then((res) => {
          return res.json();
        });
        data.avatar = response.url.split('?')[0].split('/').pop();
      }
      delete data.avatar;

      try {
        const res = await axios.post(`${serverUrl}/auth/register`, data);
        setLoading(false);

        if (res.data.error) {
          toast.error(res.data.message);
          setError(res.data.message);
        } else {
          setIsVerification(true);
          setSend(true);
        }
      } catch (error) {
        setLoading(false);
        if (error.response) {
          setError(error.response.data.message);
        } else {
          setError('Something went wrong!');
        }
      }
    } else {
      await verifyUser(data, history);
    }
  };

  const [timer, setTimer] = useState(120);
  const [endTime, setEndTime] = useState(null);

  useEffect(() => {
    if (timer === 120) {
      // Set the end time when timer starts
      setEndTime(Date.now() + 120000);
    }
  }, [timer]);

  useEffect(() => {
    if (!endTime) return;

    const interval = setInterval(() => {
      const remaining = Math.round((endTime - Date.now()) / 1000);
      setTimer(remaining > 0 ? remaining : 0);
    }, 1000);

    return () => clearInterval(interval);
  }, [endTime]);

  const resetTimer = () => {
    setTimer(120);
    setEndTime(null);
  };

  useEffect(() => {
    if (!isVerification) return;
    if (isVerification) {
      resetTimer();
    }
  }, [isVerification]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const handleOtpSend = async (data) => {
    try {
      await {
        method: 'post',
        url: `${serverUrl}/auth/request-otp`,
        data: data,
      }.then((res) => {
        setIsVerification(true);
      });
    } catch (error) {
      let response = error.response && error.response;
      let data = response && response.data;
      let message = data && data.message;
      toast.alert(message || 'Something went wrong');
    }
  };

  return (
    <form className="authForm" id="registerForm" onSubmit={handleSubmit(submitForm)}>
      <div className="instructions__login">
        <div
          className="back-element d-block"
          style={{ position: 'relative', padding: '15px 0px', fontSize: '18px', color: 'black' }}
        >
          <Link className="text-muted" to="/login">
            <i className="fas fa-arrow-left" style={{ color: 'black' }}></i>
          </Link>
        </div>
        <div className="overlay__img d-lg-none d-md-none d-none">
          <img style={{ position: 'relative' }} alt="Avyaas Logo" src="/images/logo.png" />
        </div>

        <h2 className="welcom pb-0 mb-0" style={{ padding: '10px 0px 0px' }}>
          Welcome!
        </h2>
        <p className="small text-muted">Please fill the information below to sign up.</p>
      </div>
      <>
        <div className="d-flex justify-content-center">
          <div
            className="profile-picture-preview text-center"
            onClick={() => document.getElementById('avatar').click()}
            style={{ cursor: 'pointer', width: 'fit-content' }}
          >
            <input
              ref={register({
                required: false,
              })}
              type="file"
              id="avatar"
              name="avatar"
              accept="avatar/*"
              className="profile-picture-input"
              style={{ display: 'none' }}
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onload = (event) => {
                    document.getElementById('imagePreview').src = event.target.result;
                  };
                  reader.readAsDataURL(file);
                }
              }}
            />
            <img
              src="/images/profile.png"
              id="imagePreview"
              alt="Profile Preview"
              className="profile-picture-img"
              style={{ borderRadius: '50%', width: '100px', height: '100px', objectFit: 'cover' }}
            />
            <label htmlFor="avatar" className="profile-picture-label">
              Profile Picture
            </label>
            <div className="input-error">{errors.avatar && errors.avatar.message}</div>
          </div>
        </div>
        <div className="register-container">
          <div className={errors.first_name ? 'errorfield inputGroup' : 'inputGroup'}>
            <input
              ref={register({
                required: 'First name is required',
                maxLength: {
                  value: 100,
                  message: 'First name should be not more than length of 100',
                },
              })}
              disabled={send}
              name="first_name"
              type="text"
              id="first_name"
              placeholder="First Name"
            />
            <label className="input-icon-label" htmlFor="first_name">
              <i className="fa fa-user" aria-hidden="true"></i>
            </label>
            <div className="input-error">{errors.first_name && errors.first_name.message}</div>
          </div>

          <div className={errors.middle_name ? 'errorfield inputGroup' : 'inputGroup'}>
            <input
              ref={register({
                required: false,
                maxLength: {
                  value: 100,
                  message: 'Middle name should be not more than length of 100',
                },
              })}
              disabled={send}
              name="middle_name"
              type="text"
              id="middle_name"
              placeholder="Middle Name"
            />
            <label className="input-icon-label" htmlFor="middle_name">
              <i className="fa fa-user" aria-hidden="true"></i>
            </label>
            <div className="input-error">{errors.middle_name && errors.middle_name.message}</div>
          </div>

          <div className={errors.last_name ? 'errorfield inputGroup' : 'inputGroup'}>
            <input
              ref={register({
                required: 'Last name is required',
                maxLength: {
                  value: 100,
                  message: 'Last name should be not more than length of 100',
                },
              })}
              disabled={send}
              name="last_name"
              type="text"
              id="last_name"
              placeholder="Last Name"
            />
            <label className="input-icon-label" htmlFor="last_name">
              <i className="fa fa-user" aria-hidden="true"></i>
            </label>
            <div className="input-error">{errors.last_name && errors.last_name.message}</div>
          </div>

          <div className={errors.email ? 'errorfield inputGroup' : 'inputGroup'}>
            <input
              ref={register({
                required: 'Email is required',
                pattern: {
                  value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                  message: 'Email is invalid',
                },
                maxLength: {
                  value: 254,
                  message: 'Email should be not more than length of 254',
                },
              })}
              disabled={send}
              name="email"
              type="email"
              id="name"
              placeholder="Email"
            />
            <label className="input-icon-label" htmlFor="email">
              <i className="far fa-envelope"></i>
            </label>
            <div className="input-error">{errors.email && errors.email.message}</div>
          </div>

          <div className={errors.phone ? 'errorfield inputGroup' : 'inputGroup'}>
            <input
              ref={register({
                required: 'Phone number is required',
                minLength: {
                  value: 10,
                  message: 'Invalid phone number',
                },
                pattern: {
                  value: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
                  message: 'Invalid phone number',
                },
              })}
              name="phone"
              type="phone"
              disabled={send}
              id="phone"
              placeholder="Your Mobile number"
            />
            <label className="input-icon-label" htmlFor="email">
              <i className="fas fa-mobile-alt"></i>
            </label>
            <div className="input-error">{errors.phone && errors.phone.message}</div>
          </div>

          <div className={errors.guardian_phone ? 'errorfield inputGroup' : 'inputGroup'}>
            <input
              ref={register({
                required: false,
                minLength: {
                  value: 10,
                  message: 'Invalid phone number',
                },
                pattern: {
                  value: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
                  message: 'Invalid phone number',
                },
              })}
              name="guardian_phone"
              type="phone"
              disabled={send}
              id="guardian_phone"
              placeholder="Guardian Phone number"
            />
            <label className="input-icon-label" htmlFor="guardian_phone">
              <i className="fas fa-mobile-alt"></i>
            </label>
            <div className="input-error">{errors.guardian_phone && errors.guardian_phone.message}</div>
          </div>

          <div className={errors.collegename ? 'errorfield inputGroup' : 'inputGroup'}>
            <input
              ref={register({
                required: false,
                maxLength: {
                  value: 254,
                  message: 'College Name should be not more than length of 254',
                },
              })}
              disabled={send}
              name="collegename"
              type="text"
              id="collegename"
              placeholder="Your College Name"
            />
            <label className="input-icon-label" htmlFor="collegename">
              <i className="fa fa-graduation-cap" aria-hidden="true"></i>
            </label>
            <div className="input-error">{errors.collegename && errors.collegename.message}</div>
          </div>

          <div className={errors.address ? 'errorfield inputGroup' : 'inputGroup'}>
            <input
              ref={register({
                required: false,
                maxLength: {
                  value: 254,
                  message: 'Address should be not more than length of 254',
                },
              })}
              disabled={send}
              name="address"
              type="text"
              id="address"
              placeholder="Your Current Address"
            />
            <label className="input-icon-label" htmlFor="address">
              <i className="fa fa-map-marker"></i>
            </label>
            <div className="input-error">{errors.address && errors.address.message}</div>
          </div>

          <div className={errors.password ? 'errorfield inputGroup' : 'inputGroup'}>
            <input
              ref={register({
                required: 'Password is required',
                pattern: {
                  value: /^.{6,}$/,
                  message: 'Password must have at least 6 characters',
                },
              })}
              name="password"
              type={showPass ? 'text' : 'password'}
              disabled={send}
              id="password"
              placeholder="Password"
            />
            <label className="input-icon-label" htmlFor="email">
              <i className={`fa ${showPass ? 'fa fa-eye-slash' : 'fa fa-eye'}`} onClick={togglePassword}></i>
            </label>
            <div className="input-error">{errors.password && errors.password.message}</div>
          </div>

          <div className={errors.password ? 'errorfield inputGroup' : 'inputGroup'}>
            <input
              ref={register({
                required: 'Confirm Password is required',
                validate: (value) => {
                  return value === watchPass || 'Password does not match!';
                },
              })}
              name="confirm"
              type={showPass ? 'text' : 'password'}
              disabled={send}
              id="confirm"
              placeholder="Confirm Password"
            />
            <label className="input-icon-label" htmlFor="email">
              <i className={`fa ${showPass ? 'fa fa-eye-slash' : 'fa fa-eye'}`} onClick={togglePassword}></i>
            </label>
            <div className="input-error">{errors.confirm && errors.confirm.message}</div>
          </div>

          <div className={errors.gender ? 'errorfield inputGroup' : 'inputGroup'}>
            <select ref={register({ required: false })} disabled={send} name="gender" id="gender">
              <option value="">Select Gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
            <label className="input-icon-label" htmlFor="gender">
              <i className="fa fa-venus-mars" aria-hidden="true"></i>
            </label>
            <div className="input-error">{errors.gender && errors.gender.message}</div>
          </div>
        </div>
      </>
      {send && (
        <div className={errors.token ? 'errorfield inputGroup' : 'inputGroup'}>
          <input
            ref={register({ required: 'Otp code is required' })}
            name="token"
            type="text"
            id="token"
            placeholder="Otp code"
          />
          <label className="input-icon-label" htmlFor="token">
            <i className="fas fa-mobile-alt"></i>
          </label>
        </div>
      )}

      {send && (
        <div className="inputGroup pt-3 pb-3 center-block">
          <p className="text-muted small">
            Didn’t receive the OTP?{' '}
            <p
              className="text-muted small"
              onClick={() => {
                timer === 0 && handleOtpSend({ phone: watch('phone') });
                setIsVerification(false);
              }}
            >
              Resend OTP&nbsp;
            </p>
            {timer > 0 ? ` in ${timer > 0 && formatTime(timer)}` : ''}
          </p>
        </div>
      )}

      <div className="error mt-2">{error}</div>

      <div className="d-flex align-items-start mt-4" style={{ gap: '10px' }}>
        <input
          type="checkbox"
          name="termsandconditions"
          id="termsandconditions"
          className="mt-1"
          ref={register({ required: 'Please agree to terms and conditions' })}
        />
        <p htmlFor="termsandconditions" className="small">
          I agree to the{' '}
          <Link to="/terms-and-conditions" className="text-primary">
            Terms & Conditions
          </Link>{' '}
          and{' '}
          <Link to="/privacy-policy" className="text-primary">
            Privacy Policy
          </Link>
        </p>
      </div>
      <div className="input-error">{errors.termsandconditions && errors.termsandconditions.message}</div>

      <div className="inputGroup d-inline ">
        <div className="btn btn-block p-0 my-2 pt-3">
          <button id="register" className="btn btn-dark rounded shadow register modified">
            {loading ? 'Loading' : 'Register'}
          </button>
        </div>
      </div>
    </form>
  );
}

export default withRouter(RegisterFrom);
